import React, { useEffect, useState } from 'react'
import { FaSearch, FaList, FaPlus, FaInbox, FaCodeBranch } from "react-icons/fa";
import { useLocation } from 'react-router';
import ArticleAdminRead from './ArticleAdminRead';
import ArticleAdminCreate from './ArticleAdminCreate';
import ArticleAdminEdit from './ArticleAdminEdit';
import ArticleAdminList from './ArticleAdminList';
import NewsAdminCreate from './NewsAdminCreate';
import NewsAdminList from './NewsAdminList';

function ArticleAdmin() {
      const location = useLocation()
      const [activeAction,setActiveAction] = useState(null)
    
      const navItems = [
        { label: 'Create Article',  path: '/staff/article/create/',tab:'create-article' },
        { label: 'Create News',  path: '/staff/article/createnews/',tab:'create-news' },
        { label: 'Article',  path: '/staff/article/detail/',tab:'article-detail-view'  },
        { label: 'Edit Article',  path: '/staff/article/edit/',tab:'edit-article' },
        { label: 'List Articles',  path: '/staff/articles/',tab:'list-articles' },
        { label: 'List News',  path: '/staff/articles/',tab:'list-news' },
      ];
    
      
    
       useEffect(()=>{
          // console.log(location)
          if(location?.pathname==="/staff/article/create/" && activeAction !== "create-article"){
            setActiveAction("create-article")
          }else if(location?.pathname==="/staff/article/createnews/" && activeAction !== "create-news"){
            setActiveAction("create-news")
          }else if(location?.pathname.includes("/staff/article/detail/") && activeAction !== "article-detail-view"){
            setActiveAction("article-detail-view")
          }else if(location?.pathname==="/staff/article/edit/" && activeAction !== "edit-article"){
            setActiveAction("edit-article")
          }else if(location?.pathname==="/staff/articles/" && activeAction !== "list-articles"){
            setActiveAction("list-articles")
          }else if(location?.pathname==="/staff/articles/news/" && activeAction !== "list-news"){
            setActiveAction("list-news")
          }
        },[location])

         useEffect(()=>{
          if(location?.state?.redirect){
            console.log(location?.state?.redirect)
            setActiveAction(location?.state?.redirect)
          }
        },[location])
    
        const CreateArticle = (e)=>{
          e.preventDefault()
          setActiveAction("create-article")
        }
    
        const EditArticle = (e)=>{
          e.preventDefault()
          setActiveAction("edit-article")
        }
    
        const ListArticles = (e)=>{
          e.preventDefault()
          setActiveAction("list-articles")
        }

        const ListNews = (e)=>{
          e.preventDefault()
          setActiveAction("list-news")
        }
        const CreateNews = (e)=>{
          e.preventDefault()
          setActiveAction("create-news")
        }
    
  
        const views = {
          "create-article":<ArticleAdminCreate/>,
          "create-news":<NewsAdminCreate/>,
          "edit-article":<ArticleAdminEdit/>,
          "article-detail-view":<ArticleAdminRead/>,
          "list-articles": <ArticleAdminList/>,
          "list-news": <NewsAdminList/>,
        }
  
  
    return (
      <div>
          {/* <h3>ProjectAdmin</h3> */}
      <header className="projects-header-admin">
        <h1 className="header-title-admin">{activeAction?.includes("news")?`News DashBoard`:`Articles DashBoard`}</h1>
  
        <div className="header-controls-admin">
          <div className="search-container">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Type / to search"
              className="search-input"
            />
          </div>
  
          <div className="icon-group">
          <button className="icon-button tooltip-container" onClick={CreateNews}>
              <FaPlus /> <span>News</span> <span class="tooltip-content">News</span>
            </button>
            <button className="icon-button tooltip-container" onClick={CreateArticle}>
              <FaPlus /> <span>New Article</span> <span class="tooltip-content">New Article</span>
            </button>
            <button className="icon-button tooltip-container" onClick={ListArticles}>
              <FaList /> <span>View Articles</span> <span class="tooltip-content">List All Articles</span>
            </button>
            <button className="icon-button tooltip-container" onClick={ListNews}>
              <FaList /> <span>View News Items</span> <span class="tooltip-content">List All News</span>
            </button>
            <button className="icon-button">
              <FaCodeBranch />
            </button>
            <button className="icon-button">
              <FaInbox />
            </button>
          </div>
        </div>
      </header>
  
      <div>
          {
            views[activeAction] || views['list-articles']
          }
      </div>
      </div>
    )
}

export default ArticleAdmin